import { Message } from '@easylife365/react';
import { useTranslation } from 'react-i18next';
import type { MissingPermissionMessageProps } from './types';

const MissingPermissionMessage: React.FC<MissingPermissionMessageProps> = ({ show }) => {
  const { t } = useTranslation('common');

  if (!show) return null;

  return <Message message={t('missingPermission')} />;
};

export default MissingPermissionMessage;
